import { Request, Response } from "express"

import { getTime, putTime } from "#services/recipe/time"

export const getRecipeTime = async (req: Request, res: Response) => {
	const list = await getTime({
		id: req.params.recipeID,
	})

	res.json(list)
}

export const updateRecipeTime = async (req: Request, res: Response) => {
	const results = await putTime(req.body)

	if (results.error && results.error.errno && results.error.errno > 0) {
		res.status(500).send(results)
	} else {
		res.send(req.body)
	}
}
